import { c as _c } from "react/compiler-runtime";
import { AddIcon } from '@systemeio/ui/icons';
import { CurrencyEnum, PaymentMethodEnum, PrimaryButton, Tooltip } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import DigitalProduct from 'modules/digital-product';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import ProductWrapper from 'modules/funnels/funnel/components/offer-settings/product-wrapper';
import { useFunnelStepData } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/hooks/use-funnel-step-data';
import { OfferFormEditType, OfferFormViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface';
import PhysicalProductSelector from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/components/physical-product-selector';
import { OfferTypeEnum } from 'modules/funnels/funnel/enums/offer-type-enum';
import DeliveredBoxIcon from 'modules/funnels/funnel/icons/delivered-box-icon';
import TrashIcon from 'modules/funnels/funnel/icons/trash-icon';
import React, { useEffect, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { handleOfferPricePlansErrors } from 'modules/digital-product/price-plans/utils/handle-offer-price-plans-errors';
interface OfferBumpSettingsProps {
  currency: CurrencyEnum;
  offerBumps: OfferFormViewInterface['offer']['bumps'];
  onSaveBump: (bumps: OfferFormEditType['bumps']) => Promise<void>;
  paymentMethods: PaymentMethodEnum[];
}
function OfferBumpSettings(t0) {
  const $ = _c(20);
  const {
    offerBumps,
    onSaveBump,
    currency,
    paymentMethods
  } = t0;
  const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] = useState(false);
  const [bump, setBump] = useState(null);
  const {
    funnelStepData,
    mutateFunnelStepData
  } = useFunnelStepData();
  const hasUserAvailableBumps = funnelStepData && funnelStepData.bumpsCount > 0;
  const hasUserPaymentMethods = paymentMethods.length > 0;
  const isAddOrderBumpVisible = hasUserAvailableBumps && hasUserPaymentMethods;
  const getDisableAddOrderBumpButtonReason = () => {
    if (!hasUserAvailableBumps) {
      return t("dashboard.funnel.configuration.offer.order_bump_limit_description");
    }
    if (!hasUserPaymentMethods) {
      return <>{t("dashboard.funnel.configuration.offer.need_payment_methods_description")}<br /><LinkWithoutPrefetch target="_blank" className="primary-link w-full" href="/profile/payment-gateways">{t("dashboard.funnel.configuration.offer.go_to_payment_gateway_link_description")}</LinkWithoutPrefetch></>;
    }
  };
  let t1;
  if ($[0] !== offerBumps[0] || $[1] !== offerBumps.length) {
    t1 = () => {
      if (offerBumps.length) {
        const bumpView = offerBumps[0];
        if (bumpView) {
          setBump({
            product: bumpView.product,
            digitalProduct: bumpView.digitalProduct
          });
        } else {
          setBump(null);
        }
      } else {
        setBump(null);
      }
    };
    $[0] = offerBumps[0];
    $[1] = offerBumps.length;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== offerBumps) {
    t2 = [offerBumps];
    $[3] = offerBumps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== mutateFunnelStepData || $[6] !== onSaveBump) {
    t3 = async () => {
      await onSaveBump([]);
      await mutateFunnelStepData(_temp, false);
    };
    $[5] = mutateFunnelStepData;
    $[6] = onSaveBump;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleRemoveBump = t3;
  let t4;
  if ($[8] !== onSaveBump) {
    t4 = async data_0 => {
      ;
      try {
        await onSaveBump(data_0);
      } catch (t5) {
        const e = t5;
        if (e instanceof BadRequest) {
          handleOfferPricePlansErrors(e.errors);
        }
        throw e;
      }
    };
    $[8] = onSaveBump;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSaveBump = t4;
  const {
    t: t5
  } = useLocoTranslation();
  const t = t5;
  const t6 = !bump ? <div className="mt-10 flex justify-center"><Tooltip disabled={isAddOrderBumpVisible} mode="hover" label={getDisableAddOrderBumpButtonReason() ?? " "} stayOnHover={true}><PrimaryButton type="button" onClick={() => setBump({
        product: null,
        digitalProduct: null
      })} disabled={!isAddOrderBumpVisible}><AddIcon />{t("dashboard.funnel.configuration.offer.order_bump_add")}</PrimaryButton></Tooltip></div> : <div className="bo-color-[rgb(var(--brand-primary-subtle))] mt-10 flex flex-col gap-3 px-4 lg:px-0"><div className="flex items-center justify-between"><div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3"><div className="text-brand-primary flex flex-row items-center gap-1 text-sm font-normal lg:text-[15px]"><DeliveredBoxIcon /><span>{t("dashboard.funnel.configuration.offer.order_bump")}</span></div><span className="text-sm font-normal">{t("dashboard.funnel.configuration.offer.order_bump_description")}</span></div><TrashIcon className="shrink-0 cursor-pointer" onClick={() => setIsRemoveConfirmationOpen(true)} /></div><ProductWrapper digitalProduct={bump.digitalProduct} product={bump.product}>{type => <>{type === OfferTypeEnum.physical && <PhysicalProductSelector product={bump.product?.id || null} onSave={data_1 => handleSaveBump([{
          product: data_1,
          digitalProduct: null
        }])} currency={currency} />}{type === OfferTypeEnum.digital && <DigitalProduct source={DigitalProductSourceEnum.Funnel} currency={currency} paymentMethods={paymentMethods} product={bump.digitalProduct} onSave={data_2 => handleSaveBump([{
          product: null,
          digitalProduct: data_2
        }])} isBump={true} />}</>}</ProductWrapper></div>;
  const T0 = Confirmation;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsRemoveConfirmationOpen(false);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = t("dashboard.funnel.configuration.offer.order_bump_confirmation");
  let t9;
  if ($[11] !== T0 || $[12] !== handleRemoveBump || $[13] !== isRemoveConfirmationOpen || $[14] !== t7 || $[15] !== t8) {
    t9 = <T0 opened={isRemoveConfirmationOpen} onClose={t7} onConfirm={handleRemoveBump} confirmationText={t8} />;
    $[11] = T0;
    $[12] = handleRemoveBump;
    $[13] = isRemoveConfirmationOpen;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <>{t6}{t9}</>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}
function _temp(data) {
  if (data) {
    return {
      ...data,
      bumpsCount: data.bumpsCount + 1
    };
  }
}
export default OfferBumpSettings;